export default  () =>  window.__SYSCFG
